package com.essntl.uikit.components.iconbutton.primary

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import com.essntl.uikit.components.button.EsButtonSize
import com.essntl.uikit.components.button.primary.getPrimaryButtonColors
import com.essntl.uikit.components.iconbutton.EsIconButton
import com.essntl.uikit.theme.esColorScheme

@Composable
fun EsLargePrimaryIconButton(
    onClick: () -> Unit,
    iconRes: String,
    enabled: Boolean = true,
    loading: Boolean = false,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    modifier: Modifier = Modifier,
) {
    val essntlColorScheme = MaterialTheme.esColorScheme

    EsIconButton(
        onClick = onClick,
        size = EsButtonSize.Large,
        colors = getPrimaryButtonColors(essntlColorScheme),
        iconRes = iconRes,
        enabled = enabled,
        loading = loading,
        interactionSource = interactionSource,
        modifier = modifier,
    )
}